import { Box } from "@mui/material"
import { Buttons } from "../../../../../../core/global/forms/Button"
import { Fields } from "./Fields"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { rqx } from "../../../../../../core/request/API"
import { env } from "../../../../../../core/Env"
import { useContext } from "react"
import { ToolContext } from "../../../../../../core/context/ToolContext"

export const ConForm = ({ SendFeatureLogs, match, ctgyData, categoryType, concernForm, setConcernForm, ctgyTypeList, handleInputConcern, __SESSION, handleTeamList, teamList, __init }) => {
    const { speakout_state,install_state } = useContext(ToolContext)
    const { message, successOpen, saveLoader } = speakout_state
    const nav =  useHistory()
    const handleBack = () => {
        nav.push('/speakout/concern/list')
        setConcernForm([{
            id: 0,
            concern_num: '',
            category: '',
            team: '',
            details: '',
            type: '',
            active: 1,
            status: 1,
            created_at: '',
            feedback: '',
            feedback_date: '',
            remove: false,
        }])
    }

    const handleSave = async() => {
        if (match.params === 'create') {
            saveLoader.set(true)
            let body = {...concernForm, company_id:__SESSION.data.uaccess[0].company_id, user_id:atob(__SESSION.data.ainfo.aid).split('_', 2)[1]}
            let res = await rqx.post(`<<tool>>/${env() === 'dev' ? 'local' : env()}/biz/concern/create`, body)
            if (res.message === 'success') {
                SendFeatureLogs(1)
                successOpen.set(true)
                message.set('Concern successfully submitted.')
                nav.push('/speakout/concern/list')
                saveLoader.set(false)
                __init(0, '')
                setConcernForm([{
                    id: 0,
                    concern_num: '',
                    category: '',
                    team: '',
                    details: '',
                    type: '',
                    active: 1,
                    status: 1,
                    created_at: '',
                    feedback: '',
                    feedback_date: '',
                    remove: false,
                }])
            }
        }
    }
    
    return (
        <Box height="100%" width="100%"  sx={{transition: 'bottom 0.3s ease 0s'}}>
            <Box bgcolor="#ECECEC"  minHeight="50px" borderRadius="10px" p={3}  display="flex" justifyContent="space-between" alignItems="center" >
                <Box fontSize="16px" fontWeight="700">{match.params === 'create' ? 'Add Concern' : 'Update Concern'}</Box>
            </Box>
            {
                match.params === 'create' &&
                <Box fontSize="12px" color="red" display="flex" justifyContent="flex-end" mt={2}>* All Fields are required.</Box>
            }
            <Fields c match={match} categoryType={categoryType} ctgyData={ctgyData} concernForm={concernForm} setConcernForm={setConcernForm} ctgyTypeList={ctgyTypeList} handleInputConcern={handleInputConcern} __SESSION={__SESSION} handleTeamList={handleTeamList} teamList={teamList} />

            <Box bgcolor="#F5FAFF" minHeight="70px"width='100%' position="fixed" display="flex"  justifyContent='space-evenly' zIndex={1101}  sx={{transition: 'bottom 0.3s ease 0s'}} bottom={(install_state.prompt.data !== null ? 100 :50) } >
                <Buttons variant="contained" borderRadius="10px" color="cancel" width="130px" height="44px" event={()=>handleBack()} text="Back">Back</Buttons>
                <Buttons variant="contained" borderRadius="10px" width="130px" height="44px" event={()=>handleSave()} text={match.params === 'create' ? 'Save' : 'Update'} disabled={!concernForm.type || !concernForm.category || !concernForm.team || !concernForm.details }></Buttons>
            </Box> 
            
        </Box>
    )
} 